import { render, staticRenderFns } from "./SipServer.vue?vue&type=template&id=b705b9ba&scoped=true"
import script from "./SipServer.vue?vue&type=script&lang=js"
export * from "./SipServer.vue?vue&type=script&lang=js"
import style0 from "./SipServer.vue?vue&type=style&index=0&id=b705b9ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b705b9ba",
  null
  
)

export default component.exports